<template>
  <el-container class="index-container">
    <el-header class="conten-header">
      <hac-header></hac-header>
    </el-header>
    <el-container class="body-container">
      <hac-left-menu></hac-left-menu>
      <el-container class="conten-container">
        <el-main>
          <tabs></tabs>
          <div style="flex: 1;height: 100%;background: #fff;overflow: auto">
            <keep-alive   :include="cachedViews" :exclude="deCachedViews">
              <router-view :key="key"></router-view>
            </keep-alive>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>
<script>
import common from '@/components/common/'
export default {
  name: 'home',
  components: common,
  data () {
    return {
      // loading: this.$store.state.loading.load
    }
  },
  mounted () {

  },
  computed: {
    loading () {
      return this.$store.state.loading.load
    },
    cachedViews () {
      return this.$store.state.tagPage.cachedViews
    },
    deCachedViews () {
      return this.$store.state.tagPage.decachedViews
    },
    key () {
      return this.$route.path
    }
  }

}
</script>
<style scoped lang='less'>
.el-main{
  flex: 1;
  display: flex;
  flex-direction: column;
}

.index-container {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f3f4f5;
  overflow: hidden;
  .conten-header{
    height: 65px;
  }
  .body-container{
    display: flex;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    .conten-container{
      display: flex;
      flex: 1;
      min-width: 0;
      min-height: 0;
      flex-direction:column;
      overflow: hidden;
      .el-main{
        background: transparent;
        padding: 10px;
      }
    }
  }
  .left-menu{
    flex-shrink: 0;
    height: 100%;
    overflow: hidden;
  }
  .el-main{
    min-height: 0;
    overflow: hidden;
  }

  .conten-header.el-header{
    height: 60px !important;
    padding: 0;
  }
}

</style>
